import router from "@/router";
import store from "@/store";
import SecureLS from "secure-ls";
const ls = new SecureLS({ isCompression: false });

export const login = (state, payload) => {
  state.currentUser = payload.user;
  state.permissions = payload.permissions;
  state.token = payload.token;

  setAuthenticated(state, true);
  store.commit("navigation/setNavigationLinks");
};

export const setAuthenticated = (state, type) => {
  state.authenticated = type;
};

export const setEmail = (state, email) => {
  state.userEmail = email;
};

export const setDefaultPassword = (state, payload) => {
  state.currentUser.is_default_password = payload.is_default_password;
  state.token = payload.token;
};

export const logout = (state) => {
  state.currentUser = null;
  state.token = null;
  state.permissions = [];
  ls.clear();
  ls.removeAll();

  setAuthenticated(state, false);
  clearStore();

  router.push("/login");

  location.reload();
};

const clearStore = () => {
  store.commit("settings/setRoles", []);
  store.commit("settings/setUsers", []);
  store.commit("navigation/clearNavigationLinks");
  store.commit("settings/setAdvertTypes", []);
  store.commit("settings/setElectivePositions", []);
  store.commit("settings/setZones", []);
  store.commit("settings/setParties", []);
  store.commit("settings/setStates", []);
  store.commit("settings/setExpenditures", []);
  store.commit("settings/setFederalConstituencies", []);
  store.commit("settings/setStateConstituencies", []);
  store.commit("settings/setLgas", []);
  store.commit("settings/setChannels", []);
  store.commit("settings/setSenatorialZones", []);
  store.commit("settings/setReportSubmission", []);
  store.commit("settings/setReportSubmissionStatus", []);
  store.commit("settings/setSupportingDocuments", []);
  store.commit("settings/setLocations", []);
  store.commit("breadcrumbsTitle/setTitles", {});
}
